<template>
  <v-container fluid>
    <v-card class="mt-2">
      <v-card-title>
        <v-btn color="primary" @click="contactDialog=true; selectedCustomer=null; selectedKey = null">Add Contact</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="filteredContacts" :search="search" :pagination.sync="pagination">
        <template slot="items" slot-scope="props">
          <tr @click.stop="selectedKey = props.item.key; contactDialog = true; selectedCustomer = props.item.Customer">
            <td>{{ props.item.customerName }}</td>
            <td>{{ props.item.Name }}</td>
            <td>{{ props.item.EmailAddress }}</td>
            <td>{{ props.item.Phone }}</td>
            <td>{{ props.item.Mobile }}</td>
            <td>
              <v-tooltip bottom v-if="props.item.Fleet">
                <v-chip slot="activator" small><v-icon>mdi-truck</v-icon></v-chip>
                <span>Fleet</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.Comms">
                <v-chip slot="activator" small ><v-icon>mdi-phone</v-icon></v-chip>
                <span>Comms</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.Accounts">
                  <v-chip slot="activator" small><v-icon>mdi-cash-100</v-icon></v-chip>
                <span>Accounts</span>
              </v-tooltip>
            </td>
            <td>
              <v-btn icon class="mx-0" @click.stop="deleteContact(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <contact-edit-dialog @getContacts="getContacts" :customer="selectedCustomer" @setCustomer="updateCustomer" :customers="customers" :contactDialog.sync="contactDialog" :contactID="selectedKey"></contact-edit-dialog>
  </v-container>
</template>

<script>
import { updateAuditLog, fireStore } from '../firebase'
// import moment from 'moment'
export default {
  data () {
    return {
      customers: {},
      contacts: [],
      search: '',
      pagination: {
        sortBy: 'Customer',
        rowsPerPage: 25,
        page: 1,
        descending: false
      },
      selectedKey: null,
      selectedCustomer: null,
      contactDialog: false,
      headers: [
        {
          text: 'Customer',
          value: 'customerName'
        },
        {
          text: 'Name',
          value: 'Name'
        },
        {
          text: 'Email',
          value: 'EmailAddress'
        },
        {
          text: 'Phone',
          value: 'Phone'
        },
        {
          text: 'Mobile',
          value: 'Mobile'
        },
        {
          text: 'Type',
          value: 'Type',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getCustomers()
    this.getContacts()
  },
  methods: {
    getCustomers () {
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          this.customers[doc.id] = {customerName: doc.data().customerName, headOffice: doc.data().headOffice}
        })
      })
    },
    getContacts () {
      this.contacts = []
      fireStore.collection('Contacts').get()
      .then(snap => {
        snap.forEach(doc => {
          this.contacts.push({...doc.data(), key: doc.id})
        })
      })
    },
    updateCustomer (customerObj) {
      this.customers[customerObj.customer].headOffice = customerObj.headOffice
      this.$forceUpdate()
    },
    deleteContact (item) {
      confirm('Are you sure you want to delete this item?') && fireStore.collection('Contacts').doc(item.key).delete().then(() => {
        updateAuditLog('delete', 'contacts', this.user, null, null, 'added new project', item, item.Customer)
        this.getContacts()
      })
    }
  },
  computed: {
    filteredContacts () {
      let filteredContacts = []
      for (let contact in this.contacts) {
        let thisContact = JSON.parse(JSON.stringify(this.contacts[contact]))
        if (this.customers[thisContact.Customer] !== undefined) {
          thisContact.customerName = this.customers[thisContact.Customer].customerName
          filteredContacts.push(thisContact)
        }
      }
      return filteredContacts
    },
    user () {
      return this.$store.getters.userData
    }
  }
}
</script>


// WEBPACK FOOTER //
// Contacts.vue?f5360984